// extracted by mini-css-extract-plugin
module.exports = {"resetFormWrapper":"ResetPasswordPage_resetFormWrapper__n1MQq"};